export default class DominicanTime {
    private static readonly DOMINICAN_TIMEZONE = 'America/Santo_Domingo';

    static toDominicanTime(date: Date): Date {
        return new Date(date.toLocaleString("en-US", { timeZone: this.DOMINICAN_TIMEZONE }));
    }

    static nowDominicanTime(): Date {
        return this.toDominicanTime(new Date());
    }

}